// Analytics service — no-op stub (backend analytics API not yet available)

export const trackPageView = (_path: string) => {};
export const recordUserSession = () => {};
export const updateSessionOnLogout = () => {};
export const trackUserAction = async (_actionType: string, _details?: any) => {};
